export interface ValidationError {
  field: string;
  message: string;
}

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  // Password must be at least 6 characters long
  return password.length >= 6;
};

export const validateRequired = (value: string): boolean => {
  return Boolean(value && value.trim().length > 0);
};

export const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const validateLoginForm = (
  email: string,
  password: string
): ValidationError[] => {
  const errors: ValidationError[] = [];

  const emailError = validateEmail(email);
  if (!emailError) {
    errors.push({
      field: 'email',
      message: 'Please enter a valid email address',
    });
  }

  const passwordError = validatePassword(password);
  if (!passwordError) {
    errors.push({
      field: 'password',
      message: 'Password must be at least 6 characters long',
    });
  }

  return errors;
};

/**
 * Extracts the part before the @ symbol from a username or email
 * @param username - The username or email string
 * @returns The part before @ or the original string if no @ is found
 */
export const extractUsernameBeforeAt = (
  username: string | undefined
): string => {
  if (!username) return '';
  const atIndex = username.indexOf('@');
  return atIndex > 0 ? username.substring(0, atIndex) : username;
};
